import appAxios from '../../utils/appAxios.js';


export default {
    namespaced: true,

    state: {
        project: {
            Id: null,
            Name: "",
            Locales: [],
            Published: true
        },
        projectList: [],

        loading: false,
        recordsTotal: 0,

        locationList: [],
        locationRecords: 0,

        userList: [],
        userRecords: 0,

        checklist: [],
        checklistRecords: 0,



    },
    getters: {
        _getPorject: (state) => { return state.projectList },
        _getTotalRecords: (state) => { return state.recordsTotal },
        _getLoading: (state) => { return state.loading },
        _getlocationList: (state) => { return state.locationList },
        _getlocationRecords: (state) => { return state.locationRecords },
        _getuserList: (state) => { return state.userList },
        _getuserRecords: (state) => { return state.userRecords },
        _getChecklist: (state) => { return state.checklist },
        _getChecklistRecords: (state) => { return state.checklistRecords }


    },
    mutations: {
        SET_PROJECT_LIST(state, data) {

            state.projectList = []
            data.ListItems.forEach(value => {
                state.projectList.push(value)
            });
            state.recordsTotal = data.TotalItemsCount
            state.loading = false;
        },

        SET_PROJECT_LOCATİON_LIST(state, data) {
            state.locationList = []
            state.locationRecords = data.TotalItemsCount
            data.ListItems.forEach(item => {
                let object = new Object
                object.Name = item.Name
                object.CountryName = item.CountryName
                object.Code = item.Code
                object.CityName = item.CityName
                object.Id = item.Id
                object.checked = false
                state.locationList.push(object)
            })
        },

        SET_PROJECT_USER_LIST(state, data) {
            state.userList = []
            state.userRecords = data.TotalItemsCount
            data.ListItems.forEach(item => {
                let object = new Object
                object.Name = item.FullName
                object.Id = item.Id
                object.checked = false
                state.userList.push(object)
            })
        },

        SET_PROJECT_CHECKLIST(state, data) {
            state.checklist = []
            state.checklistRecords = data.TotalItemsCount
            data.ListItems.forEach(item => {
                let object = new Object
                object.Name = item.Name
                object.Id = item.Id
                object.checked = false
                state.checklist.push(object)
            })
        },
    },
    actions: {

        // PROJECT FUNCTİON

        async GET_PROJECT(_, projectId) {
            return new Promise(resolve => {
                appAxios.get(`/admin/project/get/${projectId}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve([])
                    }
                })
            })
        },

        async GET_ALL_PROJECTS({ commit, state }, payload) {
            state.loading = true;
            await appAxios.post("/admin/project/getall", payload).then(response => {
                commit("SET_PROJECT_LIST", response.data.Data)
            }).catch(() => state.loading = false)
        },

        async ADD_PROJECT(context, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/project/create", payload).then(response => {
                    resolve(response.data.Success)
                })
            })
        },

        async DELETE_PROJECT(context, payload) {
            await appAxios.post("/admin/project/delete", payload[0]).then(response => {
                if (response.data.Success) {
                    context.dispatch("GET_ALL_PROJECTS", payload[1])
                }
            })
        },

        async UPDATE_PROJECT(context, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/project/update", payload).then(response => {
                    resolve(response.data.Success)
                }
                )
            })
        },


        // PROJECT LOCATİON FUNCTİON

        async GET_PROJECT_LOCATİON({ commit }, payload) {

            await appAxios.post("/admin/Project/GetProjectLocations", payload).then(response => {

                if (response.data.Success) {
                    commit("SET_PROJECT_LOCATİON_LIST", response.data.Data)
                }

            })

        },

        async GET_PROJECT_NOT_LOCATİON(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Project/GetLocationsNotMappedToProject", payload).then(response => {

                    if (response.data.Success) {
                        resolve(response.data)
                    }
                    else {
                        resolve([])
                    }
                })
            })
        },

        async PROJECT_ADD_LOCATİON(context, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Project/AddLocationsToProject", payload).then(response => {
                    if (response.data.Success) {

                        context.dispatch("GET_PROJECT_LOCATİON", {
                            page: 1,
                            pageSize: 10,
                            projectId: payload.projectId,
                        })
                    }
                    resolve(response.data.Success)
                })
            })
        },

        async PROJECT_DELETE_LOCATİON(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Project/DeleteProjectLocation", payload).then(response => {
                    resolve(response.data.Success)
                })
            })
        },

        // PROJECT USER FUNCTİON

        async GET_PROJECT_USERS({ commit }, payload) {

            await appAxios.post("/admin/Project/GetProjectUsers", payload).then(response => {

                if (response.data.Success) {
                    commit("SET_PROJECT_USER_LIST", response.data.Data)
                }

            })

        },

        async GET_PROJECT_NOT_USERS(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Project/GetUsersNotMappedToProject", payload).then(response => {

                    if (response.data.Success) {
                        resolve(response.data)
                    }
                    else {
                        resolve([])
                    }
                })
            })
        },

        async PROJECT_ADD_USERS(context, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Project/AddUsersToProject", payload).then(response => {
                    if (response.data.Success) {

                        context.dispatch("GET_PROJECT_USERS", {
                            page: 1,
                            pageSize: 10,
                            projectId: payload.projectId,
                        })
                    }
                    resolve(response.data.Success)
                })
            })
        },

        async PROJECT_DELETE_USERS(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Project/DeleteUserProject", payload).then(response => {
                    resolve(response.data.Success)
                })
            })
        },


        // PROJECT AUDIT LIST FUNCTİON

        async GET_PROJECT_CHECKLIST({ commit, state }, payload) {

            if (payload.projectId != 0) {
                await appAxios.post("/admin/Project/GetProjectChecklists", payload).then(response => {
                    if (response.data.Success) {
                        commit("SET_PROJECT_CHECKLIST", response.data.Data)
                    }
                })
            }
            else {
                state.checklist = []
            }


        },

        async GET_PROJECT_NOT_CHECKLIST(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Project/GetChecklistsNotMappedToProject", payload).then(response => {

                    if (response.data.Success) {
                        resolve(response.data)
                    }
                    else {
                        resolve([])
                    }
                })
            })
        },

        async PROJECT_ADD_CHECKLIST(context, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Project/AddChecklistToProject", payload).then(response => {
                    if (response.data.Success) {

                        context.dispatch("GET_PROJECT_CHECKLIST", {
                            page: 1,
                            pageSize: 10,
                            projectId: payload.projectId,
                        })
                    }
                    resolve(response.data.Success)
                })
            })
        },

        async PROJECT_DELETE_CHECKLIST(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Project/DeleteProjectChecklist", payload).then(response => {
                    resolve(response.data.Success)
                })
            })
        },

        // PROJE BAŞARI SEVİYESİ İŞLEMLERİ
        async PROJECT_SAVE_PROJECT_ACHIEVEMENTLEVEL(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Project/SaveProjectAchievementLevels", payload).then(response => {
                    resolve(response.data.Success)
                })
            })
        },
        async GET_PROJECT_ACHIEVEMENTLEVEL(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/Project/GetProjectAchievements?projectId=${payload}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(false)
                    }
                })
            })
        },

    }

}